import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-helpdesk-support',
  templateUrl: './helpdesk-support.component.html',
  styleUrls: ['./helpdesk-support.component.scss']
})
export class HelpdeskSupportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
